import { render, staticRenderFns } from "./CadastroInternacaoAparelho.vue?vue&type=template&id=2dea7172&scoped=true&"
import script from "./CadastroInternacaoAparelho.vue?vue&type=script&lang=js&"
export * from "./CadastroInternacaoAparelho.vue?vue&type=script&lang=js&"
import style0 from "./CadastroInternacaoAparelho.vue?vue&type=style&index=0&id=2dea7172&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dea7172",
  null
  
)

export default component.exports